/* eslint-disable no-undef */
import { Common, color } from '@stockbit/ui';
import { ExpandButtonToggleWrapper, NotHoverIcon } from './styled';

const { IconWrapper, Button } = Common;

interface ExpandButtonToggleProps {
  className?: string;
  onExpand: (...args) => void;
}

function ExpandButtonToggle({
  className = '',
  onExpand,
}: ExpandButtonToggleProps) {
  return (
    <ExpandButtonToggleWrapper className={className}>
      <Button width="25px" height="16px" onClick={onExpand}>
        <IconWrapper>
          <NotHoverIcon
            className="icon-toolbar_down"
            color={color.midgray}
            size="14px"
          />
        </IconWrapper>
      </Button>
    </ExpandButtonToggleWrapper>
  );
}

export default ExpandButtonToggle;
